import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { LandingBg } from "../assets/images";
import BookSuccessBanner from "../components/SuccessfulBooking/BannerBookSuccessful";
import BookingDone from "../components/SuccessfulBooking/BookingDone";
import DownloadApp from "../components/SuccessfulBooking/DownloadApp";
import BookSuccessFooter from "../components/SuccessfulBooking/SuccessBookingFooter";
import { checkoutTicket } from "../services/cartServices";
import { BookSuccessBg } from "../assets/images";
import { trackFBEvent } from "../analytics";
import { EVENT } from "../analytics/constants";
import CustomLoader from "../components/Loader";

const SuccessfulBooking = () => {
  let [searchParams] = useSearchParams();
  const [loading, setLoader] = useState(false);
  let insertId = searchParams.get("insertId");
  const [data, setData] = useState({});
  let type = localStorage.getItem("type");
  const navigate = useNavigate();

  useEffect(() => {
    fetchTicket();
  }, []);

  useEffect(() => {
    trackFBEvent(EVENT.CURRENT_SCREEN, { page: "Success Booking Page" });
  }, []);

  const fetchTicket = async () => {
    setLoader(true);
    try {
      let res = await checkoutTicket(insertId);
      setData(res?.data?.data);
      console.log(res?.data?.data);
    } catch (err) {
      console.log(err);
      navigate("/auth/home");
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      {loading ? (
        <CustomLoader />
      ) : (
        <BookSuccessContainer>
          {/* <BannerContainer>
            <BookSuccessBanner />
          </BannerContainer> */}
          {/* <BannerSecondImageDiv>
            <BannerSecondImage src={BookSuccessBg} />
          </BannerSecondImageDiv> */}
          <SecondSubView>
            <BookingDone
              guest={type === "guest"}
              isSpinPromo={data?.spinWheelPromo}
              outletId={data?.outletId}
            />
            <DownloadApp />
          </SecondSubView>
          {/* <BookSuccessFooter /> */}
        </BookSuccessContainer>
      )}
    </>
  );
};
export default SuccessfulBooking;

const BannerSecondImageDiv = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  top: 14rem;
`;
const BannerSecondImage = styled.img`
  width: 35%;
  resize: contain;
  @media only screen and (max-width: 768px) {
    width: 70%;
  }
`;

const BookSuccessContainer = styled.div`
  /* background-image: url(${LandingBg}); */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  @media only screen and (max-width: 768px) {
    background-image: none;
  }
`;
const SecondSubView = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const BannerContainer = styled.div`
  height: 29rem;
  @media only screen and (max-width: 768px) {
    height: 22rem;
  }
`;
